module.exports = {
  defaultLangKey: 'es',
  langs: ['en', 'es', 'it', 'pt'],
};
